export default {
    container: {
        minHeight: '79px',
        borderRadius: '8px',
        boxShadow: '0px 10px 10px rgba(38, 38, 38, 0.05)',
        padding: '20px 15px',
        display: 'flex',
        flexDirection: 'row',
        columnGap: '16px',
        alignItems: 'start',
        marginBottom: "20px"
    },

    highlighted: {
        border: "1.5px solid #83CFA4",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        borderBottom: "3px solid #83CFA4",
        borderRight: "3px solid #83CFA4",
    }
}
